import { Tabs } from 'bonfire-kindling';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useFeatureFlags } from 'helpers/hooks';

const formatTotal = total => (total === null ? '' : ` (${total})`);
const commonTabProps = { tabIndex: 0, style: { boxShadow: 'none', background: 'initial' } };

export default ({ totalRecommended, totalFollowing, totalAll, totalSaved, activeTab }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { isFlagEnabled } = useFeatureFlags();

  // TODO: PV-1448, saved search tab should display the name of the current search profile.
  const onChange = (e, tab) => history.push(tab);
  const tabs = [
    {
      label: `${t('opportunities.tabs.recommended')}${formatTotal(totalRecommended)}`,
      value: 'recommended',
      ...commonTabProps,
    },
    {
      label: `${t('opportunities.tabs.following')}${formatTotal(totalFollowing)}`,
      value: 'following',
      ...commonTabProps,
    },
    {
      label: `${t('opportunities.tabs.all')}${formatTotal(totalAll)}`,
      value: 'all',
      ...commonTabProps,
    },
    isFlagEnabled('FF_25_RELEASE_TOGGLE_PV_SAVED_SEARCH')
      ? {
          label: `${t('opportunities.tabs.saved_search')}${formatTotal(totalSaved)}`,
          value: 'saved',
          ...commonTabProps,
        }
      : null,
  ].filter(tab => !!tab);

  return <Tabs value={activeTab} onChange={onChange} tabs={tabs} variant="scrollable" />;
};
